import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {MenuItem} from "primeng/api";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {WidgetToolbarCallbackInterface} from "../../../../../core/shared/widget/widget-toolbar-callback.interface";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../core/shared/helper/widget-function-call-back-create";

@Component({
    selector: 'ci-insurable-object',
    templateUrl: './ci-contract-insurable-object.component.html',
    standalone: false
})
export class CiContractInsurableObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {


    tabItems: MenuItem[];
    selectedTabItem: MenuItem;
    tabIndex: string = 'ci.ContractObject';
    widgetContractInsurableObject: WidgetData;
    widgetInsurableObject: WidgetData;
    widgetObjectCoverages: WidgetData;

    ngOnInit() {
        super.ngOnInit();

        this.tabItems = [
            {id: "ci.ContractObject", label: "Zuweisung", icon: "fa-light fa-link"},
            {id: "ci.InsurableObject", label: "Objekt", icon: "fa-light fa-circle"},
            {id: "ci.ObjectCoverages", label: "Deckungen", icon: "fa-light fa-shield-halved"},
        ];
        this.selectedTabItem = this.tabItems[0];
    }

    /**
     * On Object Change.
     */
    onObjectChanged() {

        // ⚠ THE RESULT MUST BE ASSIGNED. The factory is pure - it returns a `WidgetData` and stores
        // nothing - so a bare call built the widget and threw it away, leaving `widgetContractInsurableObject`
        // undefined and the „Zuweisung" tab blank. The persons twin
        // (`ci-contract-person.component.ts#onObjectChanged`) shows the same call assigned.
        //
        // The object id is passed for the same reason: `createWidgetObjectWithCallback` defaults it to
        // 0, and a form widget on object 0 addresses no row. `objectIdentifier.objectId` is the id this
        // component is already mounted on - `refreshCoveragesWidget` below filters on the identical value.
        this.widgetContractInsurableObject = WidgetFactory.createWidgetObjectWithCallback(
            "ci.insurable.object.contract.form",
            "Vertragszuweisung",
            "ci.ContractInsurableObject",
            {
                onFunctionObjectDefaultNew(widgetData: WidgetData): WidgetToolbarCallbackInterface {
                    return null;
                }
            },
            this.objectIdentifier.objectId
        );

        this.refreshCoveragesWidget();
    }

    refreshCoveragesWidget() {
        const filter = [FilterCriteria.create('e.contractInsurableObjectId', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)];

        this.widgetObjectCoverages = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            "ci.contract.insurable.object.coverages.new",
            'Deckungen',
            'ci.ContractInsurableObjectCoverage',
            filter
        );

        const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'contractInsurableObjectDtoId', fieldValue: this.objectIdentifier.objectId}];
        this.widgetObjectCoverages.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    onActiveItemChange(event: string | number){
        this.selectedTabItem = this.tabItems.find(item => item.id === event);
        this.tabIndex = event as string;
    }
}
